'use client';
'use client';
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import Link from "next/link";
import { asLinkAttrs } from './_node_modules/@prismicio/client/dist/helpers/asLinkAttrs.js';
const PrismicNextLink = React.forwardRef(function PrismicNextLink2(props, ref) {
  const { field, document, linkResolver, children, ...restProps } = props;
  const { href: computedHref, rel: computedRel, ...attrs } = asLinkAttrs(field ?? document, {
    linkResolver,
    rel: typeof restProps.rel === "function" ? restProps.rel : void 0
  });
  const href = ("href" in restProps ? restProps.href : computedHref) || "";
  let rel = computedRel;
  if ("rel" in restProps && typeof restProps.rel !== "function") {
    rel = restProps.rel;
  }
  return jsx(Link, { ref, ...attrs, ...restProps, href, rel, children: "children" in props ? children : field == null ? void 0 : field.text });
});
export {
  PrismicNextLink
};
//# sourceMappingURL=PrismicNextLink.js.map
